import type { HelpFile } from '../../types/help'
import { ErrorBannerTestIds } from '../../../testids/ErrorBannerTestIds'

export const errorBannerHelp: HelpFile = {
  docPage: '/docs/help-system/error-handling',
  texts: {
    [ErrorBannerTestIds.errorBanner]:
      'The last request failed — expand for the error code, or follow the link to the error log entry.',
    [ErrorBannerTestIds.errorRetry]:
      'Retry the failed request — useful for transient network errors or brief upstream timeouts.',
  },
}
